import { rfqRequestQuotePageStyles } from "@insite/content-library/Pages/RfqRequestQuotePage";
import { css } from "styled-components";


rfqRequestQuotePageStyles.loadingOverlay = {
    css: css`
        overflow: hidden;
`,
};